<form class="create-project-form space-y-6" [formGroup]="projectFormModel.form" (ngSubmit)="addProject()">
  <div class="grid grid-cols-1 gap-6">
    <section class="create-project-panel space-y-5">
      <div>
        <label for="title-input" class="form-label required">
          {{ 'INPUTS.TITLE' | translate }}
        </label>
        <input
          id="title-input"
          type="text"
          [placeholder]="'PLACEHOLDERS.PROJECT_TITLE' | translate"
          class="form-input"
          [class.is-invalid]="
            (titleFormControl?.touched || projectFormModel.form.dirty) && titleFormControl?.errors
          "
          [class.is-valid]="titleFormControl?.touched && !titleFormControl?.errors"
          [formControlName]="projectFormModel.fieldNames.title"
        />

        <div class="invalid-feedback">
          @if (titleFormControl?.errors?.['required']) {
            <span>{{ 'ERRORS.REQUIRED' | translate }}</span>
          }

          @if (titleFormControl?.errors?.['maxlength']) {
            <span>
              {{
                'ERRORS.MAXLENGTH'
                  | translate
                    : {
                        requiredLength: titleFormControl!.errors!['maxlength'].requiredLength,
                      }
              }}
            </span>
          }
        </div>
      </div>
    </section>
  </div>

  <div class="create-project-actions">
    <button type="button" class="form-secondary-btn" (click)="onCancel()">
      {{ 'BUTTONS.CANCEL' | translate }}
    </button>
    <button type="submit" class="form-primary-btn" [disabled]="projectFormModel.form.invalid">
      {{ 'BUTTONS.SAVE' | translate }}
    </button>
  </div>
</form>
